import React, { useEffect } from "react";
import { connect } from "react-redux";

import styles from "./assets/styles/main.css";

import ContentPopup from "./components/ContentPopup/ContentPopup";
import GameHeader from "./components/GameHeader/GameHeader";
import Dialog from "./components/Dialog/Dialog";
import DynamicTooltip from "./components/Tooltip/DynamicTooltip";
import Menu from "./components/Menu/Menu";
import StaticTooltip from "./components/Tooltip/StaticTooltip";
import { initState } from "./store/actions";
import CityMap from "./components/CityMap/CityMap";
import CityDialog from "./components/CityDialog/CityDialog";
import DialogOverlay from "./components/DialogOverlay";
import CommonHeader from "./components/CommonHeader/CommonHeader";
import Loader from "./components/Common/Loader";

function App(props) {
  console.log(`in app`);
  console.log(props);

  useEffect(() => {
    console.log(`use effect`);
    props.initGovernorate();
  }, []);

  if (!props.loaded) {
    return <><Loader race={"general"} /></>;
  }

  return (
    <>
      {props.idle && <Loader race={props.race?.name || "general"} />}
      <div className={`${styles.cityPage} ${props.race.name} city-page ${props.showDialog
      || props.showContentPopup ? "block-scroll" : ""}`}>
        <div style={{ position: "fixed", width: "100vw", zIndex: 20 }}>
          <header className="main-header">
            <><CommonHeader/><GameHeader/></>
          </header>
          {props.showMenu && <Menu alliance={props.alliance}/>}
          {props.showContentPopup && <ContentPopup {...props.showContentPopup}/>}
        </div>
        <CityMap />
        {props.showCityDialog && <CityDialog {...props.showCityDialog}/>}
        {props.showDialog && props.showDialog
          .map(options => <Dialog {...options}/>)
        }
        {props.showResourcesStatistics && <Dialog
            name={"StatsDialog"}
            classes={["stats-dialog"]}
        />}
        {props.showTooltip && props.showTooltip.filter(options => options.dynamic)
          .map(options => <DynamicTooltip {...options}/>)
        }
        {props.showTooltip && props.showTooltip.filter(options => options.static)
          .map(options => <StaticTooltip {...options}/>)
        }
      </div>
      {(props.showDialog || props.showContentPopup)
      && <DialogOverlay/>}
    </>
  );
}

const mapStateToProps = state => ({
  alliance: state.governorate.alliance,
  loaded: state.governorate.loaded,
  race: state.governorate.race,
  showMenu: state.ui.showMenu,
  showContentPopup: state.ui.showContentPopup,
  showCityDialog: state.ui.showCityDialog,
  showDialog: state.ui.showDialog,
  showResourcesStatistics: state.ui.showResourcesStatistics,
  showTooltip: state.ui.showTooltip,
  idle: state.ui.idle
});

const mapDispatchToProps = dispatch => ({
  initGovernorate: () => dispatch(initState())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
